import { useEffect, useRef } from "react";

const DIFERENCIAIS = [
  {
    icon: "ri-heart-2-line",
    title: "Atendimento Humanizado",
    desc: "Tratamos cada cliente como único, com empatia, escuta ativa e dedicação real ao seu caso.",
  },
  {
    icon: "ri-lightbulb-flash-line",
    title: "Estratégia Personalizada",
    desc: "Soluções jurídicas sob medida para cada situação, combinando técnica e criatividade na defesa dos seus interesses.",
  },
  {
    icon: "ri-eye-line",
    title: "Transparência Total",
    desc: "Comunicação clara e honesta em todas as etapas do processo. Você sempre saberá o que está acontecendo.",
  },
  {
    icon: "ri-time-line",
    title: "Agilidade e Eficiência",
    desc: "Respostas rápidas, prazos cumpridos e atuação dinâmica para resultados no menor tempo possível.",
  },
];

const STEPS = [
  {
    num: "01",
    title: "Atendimento Inicial",
    desc: "Entre em contato pelo WhatsApp ou formulário. Agendamos uma consulta para entender sua situação.",
  },
  {
    num: "02",
    title: "Análise do Caso",
    desc: "Estudamos profundamente seu caso, identificando os melhores caminhos jurídicos disponíveis.",
  },
  {
    num: "03",
    title: "Definição da Estratégia",
    desc: "Apresentamos um plano de ação claro, com opções e perspectivas realistas sobre o seu caso.",
  },
  {
    num: "04",
    title: "Acompanhamento Completo",
    desc: "Conduzimos todo o processo com dedicação, mantendo você informado a cada passo.",
  },
];

export default function DiferenciaisSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(".reveal-dif");
            items.forEach((item, i) => {
              setTimeout(() => {
                item.classList.add("opacity-100", "translate-y-0");
                item.classList.remove("opacity-0", "translate-y-8");
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.08 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Diferenciais */}
      <section ref={sectionRef} className="py-24 lg:py-28 bg-gray-soft">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-14">
            <div className="reveal-dif opacity-0 translate-y-8 transition-all duration-700 flex items-center justify-center gap-3 mb-6">
              <div className="h-px w-10 bg-rose-primary" />
              <span className="text-rose-primary text-xs font-medium uppercase tracking-widest">Por que nos escolher</span>
              <div className="h-px w-10 bg-rose-primary" />
            </div>
            <h2 className="reveal-dif opacity-0 translate-y-8 transition-all duration-700 font-heading text-4xl lg:text-5xl text-grafite font-semibold mb-4">
              Nossos diferenciais
            </h2>
            <p className="reveal-dif opacity-0 translate-y-8 transition-all duration-700 text-grafite/60 text-base max-w-lg mx-auto">
              O que faz do SM Advogados a escolha certa para defender seus interesses.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {DIFERENCIAIS.map((item) => (
              <div
                key={item.title}
                className="reveal-dif opacity-0 translate-y-8 transition-all duration-700 group bg-white p-7 rounded-xl border border-gray-light hover:border-rose-primary/30 transition-all text-center"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-rose-pale rounded-full mx-auto mb-5 group-hover:bg-rose-primary/20 transition-colors">
                  <i className={`${item.icon} text-rose-primary text-2xl`} />
                </div>
                <h3 className="text-grafite font-semibold text-base mb-3">{item.title}</h3>
                <p className="text-grafite/55 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Como Funciona */}
      <section className="py-24 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-14">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="h-px w-10 bg-rose-primary" />
              <span className="text-rose-primary text-xs font-medium uppercase tracking-widest">Como funciona</span>
              <div className="h-px w-10 bg-rose-primary" />
            </div>
            <h2 className="font-heading text-4xl lg:text-5xl text-grafite font-semibold mb-4">
              Do contato ao resultado
            </h2>
            <p className="text-grafite/60 text-base max-w-lg mx-auto">
              Um processo simples, transparente e eficiente para resolver sua questão jurídica.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
            {/* Connector line */}
            <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-rose-primary/20 z-0" />

            {STEPS.map((step, idx) => (
              <div key={step.num} className="relative z-10 flex flex-col items-center text-center p-6">
                <div className="w-14 h-14 flex items-center justify-center bg-rose-primary rounded-full mb-5 flex-shrink-0">
                  <span className="text-white font-heading font-semibold text-sm">{step.num}</span>
                </div>
                {idx < STEPS.length - 1 && (
                  <div className="lg:hidden absolute top-7 left-[calc(50%+28px)] right-0 h-px bg-rose-primary/20 z-0" />
                )}
                <h3 className="text-grafite font-semibold text-base mb-3">{step.title}</h3>
                <p className="text-grafite/55 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
